/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// @mui material components
import Card from '@mui/material/Card';

// Vision UI Dashboard PRO React components
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';

function Highlights() {
  const highlights = [
    "There are multiple new AI video models released in October 2025. These models include opensource (WAN Animate, WAN 2.5) and commercial models (OpenAI's Sora 2). These solutions significantly increase threat actors abilityto create deepfake & AI generated clones",
    "OpenAI's Sora 2 does not properly safeguard against misuse of NILV due to its failure to moderate prompt inputs. We are currently monitoring for infringing output from Sora 2. Based on the volume we identify, we may recommend more enhanced takedown requests with OpenAI (filtering of client's name from prompts, etc.) ",
    ];

  return (
    <Card sx={{ height: '100%', padding: '24px' }}>
      <VuiBox>
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb={2}>
          HIGHLIGHTS
        </VuiTypography>
        <VuiBox>
          {highlights.map((highlight, index) => (
            <VuiBox key={index} display="flex" mb={2}>
              <VuiBox mr={1.5} mt={1}>
                <VuiBox
                  width="6px"
                  height="6px"
                  borderRadius="50%"
                  sx={{ backgroundColor: '#0075FF' }}
                />
              </VuiBox>
              <VuiTypography variant="button" color="text" fontWeight="regular" sx={{ fontSize: '1rem' }}>
                {highlight}
              </VuiTypography>
            </VuiBox>
          ))}
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default Highlights;
